import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../../../app.config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  version: string;

  constructor(
  ) {
    this.version = AppConfig.settings.version;
  }

  ngOnInit() {
  }

}
